module.exports = {
    props: ['user', 'teams'],


    /**
     * Load mixins for the component.
     */
    mixins: [require('./../mixins/tab-state')],


    /**
     * The component's data.
     */
    data() {
        return {
            billableType: 'user',
            currentTab: '#profile',
            team: null
        };
    },


    /**
     * Prepare the component.
     */
    mounted() {
        this.usePushStateForTabs('.spark-settings-tabs');
    },

    methods: {
        changeTab(tabId) {
            this.currentTab = tabId;
            const tabs = document.querySelectorAll('.tab-pane');
            tabs.forEach(tab => tab.classList.remove('active'));
            const selectedTab = document.querySelector(tabId);
            if (selectedTab) {
                selectedTab.classList.add('active');
            }
        }
    },

    computed: {
        /**
         * Provide a user-friendly label for the current tab.
         * For a more dynamic approach, you can store
         * label-value pairs in an object or array.
         */
        currentTabLabel() {
            switch (this.currentTab) {
                case '#profile':          return this.__('Profile');
                case '#security':         return this.__('Security');
                case '#preferences':      return this.__('Preferences');
                case '#audit':            return this.__('Personal Audit');
                case '#api':              return this.__('API');
                case '#subscription':     return this.__('Subscription');
                case '#payment-method':   return this.__('Payment Method');
                case '#invoices':         return this.__('Invoices');
                case '#hotels':           return this.__('Team Settings');
                default:                  return this.__('Settings');
            }
        }
    }
};
